<template>
  <div class="item">
    <div
      class="gift-img"
      @click="
        clickStat(game)
        $util.goGiftDetail(game)
      "
    >
      <img :src="game.image" alt="游戏图片" />
    </div>
    <div class="gift-info">
      <div class="gift-desc">{{ game.title }}</div>
      <div class="gift-num">
        还剩 <em>{{ Math.max(0, game.quantity - game.granted) }}</em> 个
      </div>
    </div>
    <div class="gift-btn">
      <button
        @click="
          clickStat(game)
          $util.goGiftDetail(game)
        "
      >
        立即领取
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GiftGameItem',
  props: {
    game: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: false
    },
    statParams: {
      type: Object,
      required: false
    }
  },
  methods: {
    clickStat(game) {
      if (!this.statParams) {
        return
      }
      let eid = game.id
      let eid_desc = game.title
      if (this.statParams.type === 'number') {
        eid = this.index + 1
        eid_desc = this.index + 1
      }
      this.$util.clickStat(
        `${this.statParams.eid}${eid}`,
        `${this.statParams.eid_desc}${eid_desc}`
      )
    }
  }
}
</script>
